import React, { useState, useEffect } from "react";
import {
  CardTitle,
} from "reactstrap";
//redux
import { connect } from "react-redux";
//paginação
import Pagination from "../../../../components/Paginationv3";
// backdrops
import Alert from '../../../../components/Backdrops/Alert';
import Loading from '../../../../components/Backdrops/Loading';
// router
import { useLocation } from "react-router-dom";
//service
import faceCollectorConfigService from "../../../../utils/services/accreditation/faceCollectorConfig";
import plusXMiceIdService from "../../../../utils/services/accreditation/plusXMiceId";
import PlusXMiceIdModel from '../../../../utils/models/PlusXMiceIdModel';
import FaceCollectorConfigModel from '../../../../utils/models/FaceCollectorConfigModel';

import EventLink from './EventLink';
import EventNotActive from './EventNotActive';
import FaceRecognitionConfigList from './FaceRecognitionConfigList';

function LeadCollectorReports(props) {

  const location = useLocation();
  const eventId = location.state.idEvent;

  const [loadingControl, setLoadingControl] = useState({
    open: false,
    message: '',
  });
  const [alertControl, setAlertControl] = useState({
    open: false,
    title: '',
    message: '',
    status: '', // success, warning, error
  });
  const [plusXMiceId, setPlusXMiceId] = useState(PlusXMiceIdModel());
  const plusXMiceIdRef = React.useRef(PlusXMiceIdModel());
  const [configListForm, setConfigListForm] = useState(FaceCollectorConfigModel());

  useEffect(() => {
    plusXMiceIdRef.current = PlusXMiceIdModel();
    getData();
  }, [location.key]);

  const getData = React.useCallback(async () => {
    try {
      setLoadingControl({ ...loadingControl, open: true, message: 'Carregando' });

      let _plusXMiceId = { ...plusXMiceIdRef.current };
      if (!_plusXMiceId.miceId) {
        _plusXMiceId = await plusXMiceIdService.getPlusXMiceId(eventId);
        plusXMiceIdRef.current = _plusXMiceId;
        setPlusXMiceId(_plusXMiceId);
        if (!_plusXMiceId.active) {
          return;
        }
      }

      let _config = await faceCollectorConfigService.getFaceCollectorConfig(
        _plusXMiceId.miceId,
      );
      setConfigListForm(getDefaultConfig(_config));

    } catch (error) {
      console.log('Error getData', error);
      setAlertControl({
        open: true,
        title: 'Erro',
        message: error.message || 'Não foi possível realizar esta operação',
        status: 'error', // success, warning, error
      });
    } finally {
      setLoadingControl({ ...loadingControl, open: false });
    }
  }, []);

  const getDefaultConfig = React.useCallback((config = FaceCollectorConfigModel()) => {
    return FaceCollectorConfigModel({
      ...config,
      eventId: plusXMiceIdRef.current.miceId,
      system: 'mice',
      backgroundImage: config.backgroundImage || '',
      backgroundColor: config.backgroundColor || '#f2f2f2',
      textColor: config.textColor || '#000000',
      buttonBackgroundColor: config.buttonBackgroundColor || '#456091',
      buttonTextColor: config.buttonTextColor || '#ffffff',
      detectionType: 'aws',
    })
  }, []);

  const trySaveConfigs = React.useCallback(async () => {
    try {
      setLoadingControl({ ...loadingControl, open: true, message: 'Salvando' });

      const _errorMessage = validateForm();
      if (_errorMessage) {
        setAlertControl({
          open: true,
          title: 'Atenção',
          message: _errorMessage,
          status: 'warning', // success, warning, error
        });
        return;
      }

      await faceCollectorConfigService.saveFaceCollectorConfig(
        configListForm
      );

      setAlertControl({
        open: true,
        title: '',
        message: 'Salvo com Sucesso',
        status: 'success', // success, warning, error
      });

    } catch (error) {
      console.log('Error trySaveConfigs', error);
      setAlertControl({
        open: true,
        title: 'Erro',
        message: error.message || 'Não foi possível realizar esta operação',
        status: 'error', // success, warning, error
      });
    } finally {
      setLoadingControl({ ...loadingControl, open: false });
    }

    function validateForm() {
      if (!configListForm.backgroundColor) {
        return `Campo "Cor de Fundo" Obrigatório`;
      }
      if (!configListForm.textColor) {
        return `Campo "Cor do Texto" Obrigatório`;
      }
      if (!configListForm.buttonBackgroundColor) {
        return `Campo "Cor de Fundo do Botão" Obrigatório`;
      }
      if (!configListForm.buttonTextColor) {
        return `Campo "Cor do Texto do Botão" Obrigatório`;
      }
      return '';
    }
  }, [configListForm]);

  if (!plusXMiceId.active) {
    return (
      <EventNotActive />
    )
  }
  return (
    <div>
      <CardTitle>Configuração de Face ID</CardTitle>
      <EventLink miceId={plusXMiceId.miceId} />
      <FaceRecognitionConfigList
        configListForm={configListForm}
        setConfigListForm={setConfigListForm}
        trySaveConfigs={trySaveConfigs}
      />

      <Loading loadingControl={loadingControl} />
      <Alert
        alertControl={alertControl}
        setAlertControl={setAlertControl}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return { state };
};

export default connect(mapStateToProps)(LeadCollectorReports);
